import React from 'react';
import PropTypes from 'prop-types';

import InfoCardChoices from '../../../shared/components/InfoCardChoices';
import Paragraph from '../../../shared/components/Paragraph';
import replaceHtml from '../helpers/textFormat';

const PollResultItem = React.memo(({
  title,
  desc,
  choices,
  selected,
  small,
  userSelected,
}) => {
  const choicesWithTags = choices.map((choice) => {
    const content = replaceHtml(choice.content);
    return {
      ...choice,
      content,
    };
  });

  return (
    <>
      <Paragraph title={title} bold />
      <InfoCardChoices
        selected={selected}
        userSelected={userSelected}
        choices={choicesWithTags}
        small={small}
      />
    </>
  );
});

PollResultItem.defaultProps = {
  desc: '',
  small: true,
  title: '',
  userSelected: null,
};

PollResultItem.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  selected: PropTypes.string.isRequired,
  userSelected: PropTypes.string,
  small: PropTypes.bool,
  choices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    footer: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ]),
  })).isRequired,
};

export default PollResultItem;
